import React, { Component, type JSX } from 'react';
import { events } from '../../util/Events';
import { SearchBoosterResultsTrainingRow } from './SearchBoosterResultsTrainingRow';
import filter from 'lodash/filter';
import { TrainingSearchResult } from '../../models/Examentraining';

interface ComponentProps {
  block: any;
  type: 'distance' | 'datum_start';
  allResults: TrainingSearchResult[];
  isActive: boolean;
}

interface ComponentState {
  viewAll: boolean;
  limit: number;
}

/**
 * This component is a group of trainings on a specific tutor location
 */
export class SearchBoosterResultsBlock extends Component<ComponentProps, ComponentState> {

  constructor(props: ComponentProps) {
    super(props);

    this.state = {
      viewAll: false,
      limit: (this.props.type === 'distance') ? 3 : 6,
    };
  }

  /**
     * Toggle the hidden trainings
     */
  public toggleRows(): void {
    this.setState({ viewAll: !this.state.viewAll });
  }


  public render(): JSX.Element {
    const { viewAll, limit } = this.state;
    const { block, allResults, type, isActive } = this.props;

    /** Get training dates for this location */
    let trainingDates = filter(allResults, thisResult => {
      if (type === 'distance') {
        return thisResult.loc_naam === block.loc_naam;
      }
      return thisResult.dateGroup === block.dateGroup;

    });

    /** Show all rows or show limited amount */
    const trainingRows = trainingDates.map((training, key) => {
      if (key < ((viewAll) ? 9999999 : limit)) {
        return (<SearchBoosterResultsTrainingRow training={training} key={key} type={type}/>);
      }
    });

    let className = isActive ? 'search-results__item search-results__item--active' : 'search-results__item';
    const locAdress = block.loc_straat + ' ' + block.loc_nr;
    const locUrl = 'https://lyceo.nl/vestigingen/' + block.loc_stad + '/';
    const org_style = { display: 'none' };
    if (type === 'distance') {
      return (<div itemScope itemType="http://schema.org/LocalBusiness" className={className}
        ref={block.loc_naam}
        data-id={block.loc_naam}
        onMouseEnter={(): void => events.emit('SearchHover', block.loc_naam)}>
        <div className="search-results__item-title">
          {block.loc_stad}, {block.loc_straat} {block.loc_nr}
          <meta itemProp="name" content={block.loc_naam}/>
          <meta itemProp="latitude" content={block.loc_lat}/>
          <meta itemProp="longitude" content={block.loc_long}/>
          <div itemProp="address" itemScope itemType="https://schema.org/PostalAddress">
            <meta itemProp="streetAddress" content={locAdress}/>
            <meta itemProp="postalCode" content={block.loc_postcode}/>
            <meta itemProp="addressLocality" content={block.loc_stad}/>
          </div>
          <meta itemProp="telephone" content={block.loc_telefoon}/>
          <meta itemProp="logo" content="https://www.lyceo.nl/wp-content/themes/lyceo-2015/images/lyceo-logo.svg"/>
          <meta itemProp="url" content={locUrl}/>
          <meta itemProp="priceRange" content="Not Applicable"/>
          <span style={org_style} itemProp="parentOrganization" itemScope itemType="https://schema.org/Organization">
            <a itemProp="url" href="https://lyceo.nl/"><span itemProp="name">Lyceo</span>
            </a>
          </span>
        </div>
        <div className="search-results__item-table">
          {trainingRows}
        </div>
        {trainingDates.length > limit
                    && <ShowCompleteListButton
                      viewAll={viewAll}
                      total={trainingDates.length}
                      onClicked={(): void => this.toggleRows()}/>}
      </div>);
    }
    return (<div className="search-results__item">
      <div className="search-results__item-title">
        <strong>{block.dateGroup}</strong>
      </div>
      <div className="search-results__item-table">
        {trainingRows}
      </div>
      {trainingDates.length > limit
                && <ShowCompleteListButton
                  viewAll={viewAll}
                  total={trainingDates.length}
                  onClicked={(): void => this.toggleRows()}/>}
    </div>);

  }
}

interface ShowCompleteListButtonProps {
  total: number;
  viewAll: boolean;
  onClicked: () => void;
}

export class ShowCompleteListButton extends Component<ShowCompleteListButtonProps> {
  public render(): JSX.Element {
    const { total, viewAll, onClicked } = this.props;
    return (
      <div className="search-results__item-text" onClick={(): void => onClicked()}>
        <span className="search-results__link">
          {viewAll
            ? 'Minder weergeven'
            : `Alle ${total} trainingen weergeven`
          }
        </span>
      </div>
    );
  }
}
